import { animate, style, transition, trigger } from '@angular/animations';

const animationTime = '500ms';

export const fadeInAnimation = trigger('fadeIn', [
  transition(':enter', [
    style({ opacity: 0 }),
    // animate(animationTime + ' cubic-bezier(0.75, 0.25, 1.0, 0.25)', style({opacity: 1}))
    animate(`${animationTime} ease-in`, style({ opacity: 1 })),
  ]),
]);
